import { Outlet } from 'react-router'

import { Breadcrumb } from '@ui/components/navigation'
import { ExtraParams } from '@ui/interfaces/navigation'
import { Source } from '@ui/pages/sources/Source'
import { Sources } from '@ui/pages/sources/Sources'
import { RouteNamesEnum } from '@ui/router/routes'

export const SourceRoutes = () => ({
  name: RouteNamesEnum.SOURCES,
  path: 'sources',
  element: <Outlet />,
  handle: {
    crumb: (data: ExtraParams) => (
      <Breadcrumb crumbStyle={data.crumbStyle} to={`/instances/${data.instanceId}/sources`} label="Sources" />
    ),
  },
  children: [
    { index: true, element: <Sources /> },
    {
      path: ':sourceId',
      element: <Source />,
      handle: {
        crumb: (data: ExtraParams) => {
          return (
            <Breadcrumb
              crumbStyle={data.crumbStyle}
              to={`/instances/${data.instanceId}/sources/${data.sourceId}`}
              label={data.sourceId}
            />
          )
        },
      },
    },
  ],
})
